import { CountryCode } from "libphonenumber-js";

export const getCountryFromService = async (): Promise<CountryCode> => {
    try {
        return await fetch("https://ip2c.org/s")
            .then((response) => response.text())
            .then((response) => {
                const result = (response || "").toString();
                if (!result || result[0] !== "1") {
                    return "US" as CountryCode;
                }

                return result.substring(2, 4) as CountryCode;
            });
    } catch (e) {
        return 'US' as CountryCode;
    }
};